import { SizableText, YStackProps, YStack, XStack, shadowSmall } from '@my/ui'
import { UserAvatar } from 'app/features/user/components'
import { GroupEventRsvps } from 'app/types'

interface GroupEventRsvpStatsProps {
  rsvps?: GroupEventRsvps
  alignment?: 'left' | 'right'
}

export const GroupEventRsvpStats = ({
  rsvps,
  alignment = 'right',
  ...props
}: GroupEventRsvpStatsProps & YStackProps) => {
  if (!rsvps) return null

  const { going, maybe, lastUsers } = rsvps
  return (
    <YStack gap="$1" {...props}>
      {lastUsers && (
        <XStack jc={alignment === 'right' ? 'flex-end' : 'flex-start'}>
          {lastUsers.map((user) => (
            <UserAvatar
              key={user.id}
              src={user.avatar?.small}
              width={19}
              height={19}
              rounded
              bw={1}
              boc="$gray3"
              {...(alignment === 'left'
                ? {
                    mr: '$-2',
                  }
                : {
                    ml: '$-2',
                  })}
            />
          ))}
        </XStack>
      )}
      <SizableText ta={alignment} size="$1" color="$overlay9" fow="600">
        {maybe || 0} Interested
      </SizableText>
      <SizableText ta={alignment} size="$1" color="$overlay12" fow="600">
        {going || 0} Going
      </SizableText>
    </YStack>
  )
}
